import React, { useContext, useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import InputField from "../../Components/InputField/InputField";
import ViewNomineeDetailsModal from "../ViewNomineeDetails/ViewNomineeDetailsModal";
import { ContextAPI } from "../../common/Context/ContextApi";
import {
  FailedPopup,
  replaceUnderScoreAndCapitialize,
  sanitizedText,
} from "../../common/Utils/Utils";
import { ManageApis } from "../../common/APIS/ManageApis";
import PopupModal from "../../Components/PopupModal";
import { CustomTable } from "../../Components/CustomTable";

function MyDepositDetails() {
  const Navigate = useNavigate();
  const { state } = useLocation();
  const { token, setnotificationsDetails } = useContext(ContextAPI);
  const { accountId } = state || {};
  const [isLoading, setisLoading] = useState(false);
  const [Accdetails, setAccDeatils] = useState();
  const [remark, setRemark] = useState();
  const [isNomineeDeatilsModal, setIsNomineeDeatilsModal] = useState(false);
  const [ModalProps, setModalProps] = useState({
    open: false,
    title: "",
    message: "",
    props: [],
  });

  useEffect(() => {
    GetAccDetails();
  }, []);

  const handleBackBtn = () => {
    Navigate("/myDeposits");
  };

  //Function to get Acc Details
  const GetAccDetails = async () => {
    try {
      setisLoading(true);
      const reqstBody = {
        account_no: accountId,
      };
      let response = await ManageApis(
        "post",
        global.getFDDetails,
        reqstBody,
        token
      );
      if (response?.response_data?.status) {
        const accountList = response?.response_data?.data?.FD;
        setRemark(response?.response_data?.data?.remarks);
        setAccDeatils(accountList);
      } else {
        FailedPopup(response);
      }
    } catch (error) {
      FailedPopup(error?.message);
    } finally {
      setisLoading(false);
    }
  };

  const ChitDetailArray = [
    {
      title: "Account Holder(s)",
      value: (() => {
        const holders = Accdetails?.accountHolderDetails;
        if (!holders?.length) return null;
        return holders
          .map((h) => `${h?.firstName || ""} ${h?.lastName || ""}`.trim())
          .join(", ");
      })(),
    },
    { title: "A/C No", value: Accdetails?.accountNo },
    { title: "Product", value: Accdetails?.product },
    { title: "Scheme", value: Accdetails?.scheme },
    { title: "Branch", value: Accdetails?.branch_name },
    { title: "Account Type", value: Accdetails?.accountType },
    { title: "Interest Rate", value: Accdetails?.interestRate },
    { title: "Deposit Amount", value: Accdetails?.amountOfDeposit },
    { title: "Current Balance", value: Accdetails?.currentBalance },
    { title: "Deposit Date", value: Accdetails?.activatedDate },
    { title: "Maturity Date", value: Accdetails?.maturityDate },
    { title: "Status", value: Accdetails?.depositStatus },
    {
      title: "15G Submitted",
      value: Accdetails?.isSubmitted15G ? "Yes" : "No",
    },
    ...(Accdetails?.isSubmitted15G
      ? [{ title: "15G Submitted Date", value: Accdetails?.submittedDate_15G }]
      : []),
  ].filter((item) => item.value !== null && item.value !== "");

  const lienDetailsArray = Accdetails?.lienDetails?.map((item) => ({
    chittyNoOrAccNo: item.chittyNoOrAccNo,
    scheme: item.scheme,
    branch: item.accBranch?.name,
  }));

  const lienTableTitles = [
    {
      label: "Chitty No / Account No",
      getValue: (item) => item.chittyNoOrAccNo,
    },
    { label: "Scheme", getValue: (item) => item.scheme },
    { label: "Branch", getValue: (item) => item.branch },
  ];

  //const  SITableTitles = ['Start Date', 'End Date',  'Amount', 'Due Date','Destination A/c No', 'Branch', 'Scheme', 'Status'];
  const SIDetailsArray = Accdetails?.standingInstructionList
    ?.filter((item) => item.status === "LIVE")
    .map((item) => ({
      startDate: item.startDate,
      endDate: item.endDate,
      amount: item.amount,
      dayOfMonth: item.dayOfMonth,
      toAccount: item.toAccount,
      toAccountBranchName: item.toAccountBranchName,
      scheme: item.scheme,
      status: item.status,
    }));

  const SITableTitles = [
    { label: "Start Date", getValue: (item) => item.startDate },
    { label: "End Date", getValue: (item) => item.endDate },
    {
      label: "Amount",
      getValue: (item) => (item.amount === -1 ? "Varying" : item.amount),
      style: (item) => ({ textAlign: "right" }),
      headstyle: { textAlign: "right" },
    },
    { label: "Due Date", getValue: (item) => item.dayOfMonth },
    { label: "Destination A/c No", getValue: (item) => item.toAccount },
    { label: "Branch", getValue: (item) => item.toAccountBranchName },
    { label: "Scheme", getValue: (item) => item.scheme },
    { label: "Status", getValue: (item) => item.status },
  ];

  return (
    <Layout loading={isLoading}>
      {ModalProps?.open && (
        <PopupModal
          visible={ModalProps.open}
          handleClose={() => {
            setModalProps({ open: false });
            GetAccDetails();
          }}
          title={ModalProps?.title}
          message={ModalProps?.message}
          buttons={ModalProps?.props}
        />
      )}
      <div className="pt-3 pb-4 px-3 px-md-4 overflow-auto custom_scroll1">
        <div className="mb-3">
          <div className="align-items-lg-center d-flex flex-column flex-lg-row justify-content-between flex-wrap gap-2">
            <BackBtn title="My Deposit Details" handleBackBtn={handleBackBtn} />
            {[
              {
                text: "View Nominee Details",
                onClick: () => setIsNomineeDeatilsModal(true),
              },
              {
                text: "View Deposit Transactions",
                onClick: () =>
                  Navigate("/ViewDepositTransactions", {
                    state: { accountId: Accdetails?.accountNo },
                  }),
              },
            ].map((btn, index) => (
              <button
                key={index}
                onClick={btn.onClick}
                className="btn btn-master flex-fill flex-lg-grow-0 font_12 fw_500 px-3 px_btn rounded"
              >
                {btn.text}
              </button>
            ))}
          </div>
        </div>
        <div className="bg-white px-3 pt-3 pb-2 br_10 shadow_sm mb-3">
          <div className="row">
            {ChitDetailArray.map((item, index) => (
              <div
                key={index}
                className="col-12 col-md-6 col-lg-4 pb-0 pb-sm-2"
              >
                <div className="row">
                  <div className="col-12 col-sm-6 font_13">{item.title}</div>
                  <div className="col-12 col-sm-6 pt-1 pt-sm-0 mb-3 mb-sm-0">
                    <div className="d-flex">
                      <span className="pe-1 d-none d-sm-block">:</span>
                      <span
                        className={`word_break fw_600 font_13 ${
                          item.value == "ACTIVE"
                            ? "text-success"
                            : item.title === "15G Submitted"
                            ? item.value === "Yes"
                              ? "text-success"
                              : "text-danger"
                            : "text-black"
                        }`}
                      >
                        {item.value}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {!remark || remark === "" ? (
              ""
            ) : (
              <div className="rounded-3 bg_gray d-inline-block p-1 border font_13 mb-1 rounded-3">
                <span>Remarks :</span>
                <span className="fw_600 ps-2">{remark}</span>
              </div>
            )}
          </div>
        </div>
        {Accdetails?.lienDetails?.length > 0 && (
          <>
            <h6 className="mb-3 pt-2">Lien Details</h6>
            <CustomTable tableData={lienTableTitles} data={lienDetailsArray} />
          </>
        )}
        {Accdetails?.standingInstructionList?.length > 0 && (
          <>
            <h6 className="mb-3 pt-3 mt-2">Standing instructions</h6>
            <CustomTable tableData={SITableTitles} data={SIDetailsArray} />
          </>
        )}
      </div>
      <ViewNomineeDetailsModal
        isNomineeDeatilsModal={isNomineeDeatilsModal}
        setIsNomineeDeatilsModal={setIsNomineeDeatilsModal}
        Details={Accdetails}
      />
    </Layout>
  );
}

export default MyDepositDetails;
